console.debug("LOADING RecordingsManager.js")
import { action, flow, observable, makeObservable, computed, runInAction } from "mobx"
import { ClassAbstract } from "store/ClassTools"
import { PageAbstract } from "store/page/PageAbstract"
// IMPORTANT import to avoid circular dependency issues
import "store/page/player/source/InternalImports"
import { rootStore } from "store/RootStore"
import { TraxisError } from "store/api/TraxisError"
import { MANAGE_RECORDINGS_ACTIONS } from "store/api/ManageRecordings"
import { /*getChanges,*/ deepEqual } from "utils/CompareObjects"
//import { isEqual } from "lodash"
//import { EventDetails } from "store/qlapi/EpgService"
import { GetRecordingsMarkersItem } from "store/api/GetRecordingsMarkers"
import { Observe } from "store/page/mixin/ObserveMixin"
import { eventId, seriesId, isSeries, channelId, title } from "utils/EventHelpers"
import { sleep } from "utils/Utils"

import { getCoCoModule } from "store/page/repo/CoCoModule"
const CoCo = await getCoCoModule()

//export const RECORDINGS_GUARD_TIME = [0, 2, 5, 10, 15, 30, 60]

//class RecordingsGuardTime extends ClassAbstract {}

export const RECORDING_OPTIONS = {
	// Aufnehmen #8
	episode_record: "episode_record",

	// Aufnahme löschen #6
	episode_delete: "episode_delete",

	// Aufnahme abbrechen #7
	episode_cancel: "episode_cancel",

	// Serienaufnahme starten #1
	series_record: "series_record",

	// Serienaufnahme starten #1
	series_record_add: "series_record_add",

	// Serienaufnahme abbrechen #4b
	series_cancel: "series_cancel",

	// Serienaufnahme löschen #4a @should not be visible on detail page
	series_delete: "series_delete",

	// Aufnahme abbrechen
	series_episode_record: "series_episode_record",

	// Aufnahme abbrechen
	series_episode_cancel: "series_episode_cancel",

	// Aufnahme löschen
	series_episode_delete: "series_episode_delete",

	// For unarchive and delete modal
	archive_remove: "archive_remove"
}

class RecordingsManagerEvent extends ClassAbstract {
	oEvent
	oRecordings = null

	isLoading = false
	isDone = false
	error = null
	_buttonLists = {}
	recordedMarkers = null
	// used for fast UI transitions
	recordingState = {
		single: false,
		singleId: null,
		series: false,
		seriesId: null,
		seriesCancel: false,
		seriesDelete: false
	}
	cocoBookmarks = rootStore.page.CoCoBookmarks

	constructor(parent, path) {
		super(parent, path)
		makeObservable(this, {
			isLoading: observable,
			isDone: observable,
			error: observable.ref,
			setEvent: action,
			setLoaderVisible: action,
			setDoneStatus: action,
			resetStatus: action,
			buttonsLists: computed,
			setButtonLists: action,
			recordedMarkers: observable.shallow,
			setRecordedMarkers: action,
			recordingState: observable.deep,
			handleEpisodeRecord: action,
			handleEpisodeCancel: action,
			handleEpisodeDelete: action,
			handleSerieRecord: action,
			handleSeriesCancel: action,
			handleSeriesDelete: action,
			isRecordedAsSingle: computed,
			isEventInRecordedMarkers: computed,
			isRecordingStarted: computed
		})
	}

	setEvent(oEvent) {
		if (this.oEvent !== oEvent) {
			this.resetStatus()
			if (seriesId(oEvent)) {
				//console.debug("setEvent", oEvent)
				this.getRecordedEpisodeMarkers(oEvent)
			}
			else this.setRecordedMarkers([])
			//this.setButtonLists({})
			this.oEvent = oEvent
		}
		return this
	}

	notifyRecordingsMarkersUpdate() {
		const recordedEpisodeMarkers = this.getRecordedEpisodeMarkers(null, seriesId(this.oEvent))
		console.debug("notifyRecordingsMarkersUpdate", this.oEvent, recordedEpisodeMarkers)
		// MTVW-1035: reset recordingState.single for fast UI transitions
		if (this.isEventSeries && this.recordingState.single) this.recordingState.single = false
	}

	getRecordedEpisodeMarkers = flow(function* (event, _seriesId = null) {
		if (!_seriesId) _seriesId = seriesId(event)
		if (_seriesId) {
			const seriesMarker = this._parent.getMarker(null, _seriesId)
			//console.debug("getRecordedEpisodeMarkers", _seriesId, seriesMarker, event, eventId(event))
			if (seriesMarker) {
				// MTVW-820: performance optimization with ChildRecordings
				const seriesItems = this._parent.getMarkers(seriesMarker)
				this.setRecordedMarkers(seriesItems)
				console.debug("getRecordedEpisodeMarkers", this.recordedMarkers?.length, this.recordedMarkers, _seriesId, seriesMarker, event, eventId(event))
				/* DON'T USE, too slow with hundreds of recordings!
				const sRecs = yield this.getRecordings({ Ids: seriesMarker?.id })
				//const sRecs = this._root.api.GetRecordings({ ...{ Ids: event.event.contentId, _name: "event", isSingle: true, isRecorded: true, isNotEmpty: true, iLimit: 20, isSortDesc: true } })
				//yield sRecs.fetchDataAsync()
				if (sRecs?.DataArr?.length) console.debug("series size", sRecs?.DataArr?.length, _seriesId, sRecs?.DataArr, event, eventId(event))
				this.setRecordedMarkers(sRecs?.DataArr)
				*/
			}
			else this.setRecordedMarkers([])
		}
		else this.setRecordedMarkers([])
		return this.recordedMarkers
	})

	/*
	getRecordedEpisodeMarkersImpl = flow(function* (seriesId) {
		const seriesMarker = this._parent.getMarker(null, seriesId)
		//const seriesMarker = computed(() => this._parent.getMarker(null, seriesId)).get()
		const sRecs = this.getRecordings({ Ids: seriesMarker?.id })
		yield sRecs.fetchDataAsync()
		return sRecs
	})
	*/

	setRecordedMarkers(sRecs) {
		// series size > 0: recorded episodes
		//if (sRecs?.length > 0) console.debug("series size", sRecs?.length, sRecs)
		const recorded = []
		sRecs?.map((i, ix) => {
			//console.debug(" ", i.Name, i.StartTime, i.isSeries, i)
			recorded.push(i)
			//console.debug("item=", ix, i.Name, i.StartTime, i.State, i.Type, i.State, i.EventId, i)
		})
		this.recordedMarkers = recorded
	}

	get isEventInRecordedMarkers() {
		if (!this.recordedMarkers) return false
		const filtered = this.recordedMarkers?.filter(item => item.EventId === eventId(this.oEvent))
		if (filtered.length > 0) console.debug("isEventInRecordedMarkers", filtered)
		// filtered.length === 0: not contained in recorded episodes
		return this.marker !== null && filtered?.length > 0
	}

	get isRecordingStarted() {
		console.debug("isRecordingStarted recLen %o, recState.single %o, recState.series %o", this.recordedMarkers?.length, this.recordingState.single, this.recordingState.series)
		return this.recordedMarkers?.length > 0 || this.recordingState.single || this.recordingState.series
	}

	setLoaderVisible(bStatus) {
		this.isLoading = bStatus
		return this
	}

	setDoneStatus(bStatus) {
		this.isDone = bStatus
		return this
	}

	setButtonLists(lists) {
		this._buttonLists = lists
	}

	resetStatus() {
		this.isLoading = false
		this.isDone = false
		this.error = null
	}

	getRecordings = flow(function* (props) {
		//return this._root.api.GetRecordings({ ...{ isRecorded: true, isPlanned: true, iLimit: 2000, isChildRecordings: true, isSortDesc: false }, ...props })
		const recs = this._root.api.GetRecordings({ ...{ isRecorded: true, isPlanned: true, isNotEmpty: true, iLimit: 2000, isChildRecordings: true, isSortDesc: false }, ...props })
		yield recs.fetchDataAsync()
		//console.debug("getRecordings=", recs?.Data, recs?.Data?.isReady, recs)
		return recs
	})

	getCompletedRecAndEvtIds(removeRecordedMarkers = false) {
		const completed = this.recordedMarkers?.filter(item => item.State === "Complete")
		const completedRecIds = []
		const completedEvtIds = []
		for (var i = 0; i < completed.length; i++) {
			completedRecIds.push(completed[i].id)
			completedEvtIds.push(completed[i].EventId)
			if (removeRecordedMarkers) {
				// remove from recordedMarkers
				const index = this.recordedMarkers.findIndex(j => j.id === completed[i].id)
				if (index >= 0) this.recordedMarkers.splice(index, 1)
			}
		}
		return { recIds: completedRecIds, evtIds: completedEvtIds }
	}

	getPlannedRecAndEvtIds(removeRecordedMarkers = false) {
		const planned = this.recordedMarkers?.filter(item => item.State === "Scheduled" || item.State === "Recording")
		const plannedRecIds = []
		const plannedEvtIds = []
		for (var i = 0; i < planned.length; i++) {
			plannedRecIds.push(planned[i].id)
			plannedEvtIds.push(planned[i].EventId)
			//console.debug("State", planned[i].State, planned[i])
			if (removeRecordedMarkers) {
				// remove from recordedMarkers
				const index = this.recordedMarkers.findIndex(j => j.id === planned[i].id)
				if (index >= 0) this.recordedMarkers.splice(index, 1)
			}
		}
		return { recIds: plannedRecIds, evtIds: plannedEvtIds }
	}

	manageRecordingsAsync = flow(function* (props, showUserError = true) {
		this.isLoading = true
		this.error = null
		try {
			if (Array.isArray(props.request.Ids)) {
				for (let i = 0; i < props.request.Ids?.length; i += 20) {
					yield rootStore.api.ManageRecordings({ ...props.request, ...{ Ids: props.request.Ids.slice(i, i + 20) } }).fetchDataAsync()
				}
			} else {
				const api = rootStore.api.ManageRecordings(props.request)
				yield api.fetchDataAsync()
				this.isLoading = false
				//yield this.getRecordedEpisodeMarkers(this.oEvent)
				this.getRecordedEpisodeMarkers(this.oEvent)
				// replaced with informRecordingDeleted
				/*
				if (props.eventIds) {
					yield this.cocoBookmarks.deleteExistingBookmarks(props.eventIds, false)
				}
				*/
				return api?.Data?.Recording?.id
			}
			// series, delete also bookmarks
			// replaced with informRecordingDeleted
			/*
			if (props.eventIds) {
				yield this.cocoBookmarks.deleteExistingBookmarks(props.eventIds, false)
			}
			*/
			this.isLoading = false
		} catch (e) {
			this.isLoading = false
			this.error = TraxisError.getErrorIfInstanceOf(e)
			console.error("manageRecordingsAsync", e, this.error)
			// MTV-1774: this.error may be reset when the next request from RecordingsManager is sent,
			// latch error in player and abort further processing by throwing exception
			if (showUserError) rootStore.page.Player.error = this.error
			throw this.error
		}
		// MTVW-500
		rootStore.page.Recordings.IndexPage.refreshData()
		rootStore.page.Recordings.ListPage.refreshData()
		//yield this.getRecordedEpisodeMarkers(this.oEvent)
	})

	manageRecordingsPersonalAsync = flow(function* (recordingId, state) {
		yield this.manageRecordingsAsync({
			request: {
				ActionName: state === true ? MANAGE_RECORDINGS_ACTIONS.AddToPersonalRecordings : MANAGE_RECORDINGS_ACTIONS.DeleteFromPersonalRecordings,
				Ids: recordingId
			}
		})
	})

	handleEpisodeRecord = flow(function* (props) {
		this._parent.setTargetMarker(props, this.oEvent, { State: "Scheduled", IsPersonal: props.IsPersonal, SeriesId: null })
		this.recordingState.single = true
		let recordingId = yield this.manageRecordingsAsync({
			request: {
				ActionType: "Event",
				ActionName: "Record",
				Ids: eventId(this.oEvent),
				Arguments: {
					...{
						Location: "Network",
						GuardTimeStart: "PT10M",
						GuardTimeEnd: "PT30M"
					},
					...props.Arguments
				}
			}
		})

		this.recordingState.singleId = recordingId

		if (this.error?.isErrorRecordedAlready === true) {
			recordingId = this.error.getRecordedId
			yield this.manageRecordingsAsync({
				request: {
					ActionName: MANAGE_RECORDINGS_ACTIONS.Update,
					Ids: recordingId,
					Arguments: {
						...{
							GuardTimeStart: "PT10M",
							GuardTimeEnd: "PT30M"
						},
						...props.Arguments
					}
				}
			})
		}
		else yield this.cocoBookmarks.informRecordingCreated(eventId(this.oEvent), recordingId, null)
		yield this.manageRecordingsPersonalAsync(recordingId, props?.IsPersonal)

		console.debug("recordingId", recordingId)
		this.isDone = true
	})

	handleSerieRecord = flow(function* (props) {
		console.debug("handleSerieRecord props %o, event %o, marker %o, seriesMarker %o, recordedMarkers %o, isRecorded %o ", props, this.oEvent, this.marker, this.seriesMarker, this.recordedMarkers, this.isRecorded)
		this._parent.setTargetMarker(props, this.oEvent, { State: "Scheduled", isSeries: true, IsPersonal: props.IsPersonal, SeriesId: seriesId(this.oEvent) })
		/*
		const recorded = yield this.getRecordedEpisodeMarkers(this.oEvent)
		console.debug("handleSerieRecord", recorded, this.recordedMarkers, seriesId(this.oEvent))
		if (recorded.length === 0) yield this.handleSeriesDelete()
		*/
		this.recordingState.series = true
		this.recordingState.single = false
		//this.recordedMarkers = ["fakeMarker"]
		if (this.recordedMarkers?.length === 0) yield this.handleSeriesDelete()
		let recordingId = null
		try {
			recordingId = yield this.manageRecordingsAsync({
				request: {
					ActionType: "Series",
					ActionName: "Record",
					Ids: seriesId(this.oEvent),
					Arguments: {
						...{
							// MTVW-305: add SeedChannelId, with SeedChannelId a single recording will move to series recording
							SeedChannelId: channelId(this.oEvent),
							//SeedEventId: eventId(this.oEvent), // not used by other clients, DOES NOT RESOLVE 'already recorded' for series!
							//...(props.seedEventId && { SeedEventId: props.seedEventId }),
							Location: "Network",
							GuardTimeStart: "PT10M",
							GuardTimeEnd: "PT30M"
						},
						...props.Arguments
					}
				}
			}, false)
		}
		catch (err) {
			console.error("handleSerieRecord", err, this.error?.isErrorRecordedAlready, this.error.getRecordedId)
		}
		if (this.error?.isErrorRecordedAlready === true) {
			this._parent.closeRecordingEvent(this.oEvent)
			//this.recordingState.series = false
			if (this.isRecorded) this.recordingState.single = true
			recordingId = this.error.getRecordedId
			// series could be only deleted if no recorded markers
			//yield this.handleSeriesDelete()
			yield this.manageRecordingsAsync({
				request: {
					ActionName: MANAGE_RECORDINGS_ACTIONS.Update,
					Ids: recordingId,
					Arguments: {
						...{
							GuardTimeStart: "PT10M",
							GuardTimeEnd: "PT30M"
						},
						...props.Arguments
					}
				}
			})
			yield this.manageRecordingsAsync({
				request: {
					ActionName: MANAGE_RECORDINGS_ACTIONS.Resume,
					Ids: recordingId
				}
			})
		}
		else yield this.cocoBookmarks.informRecordingCreated(eventId(this.oEvent), recordingId, seriesId(this.oEvent))
		// MTVW-1146: workaround to make sure props?.IsPersonal is applied correctly
		/*
		yield this.manageRecordingsPersonalAsync(recordingId, props?.IsPersonal)
		console.debug("recordingId=", recordingId)
		this._parent.fetchMarkers("handleSerieRecord")
		*/
		sleep(10000).then(() => {
			this.manageRecordingsPersonalAsync(recordingId, props?.IsPersonal).then(() => {
			console.debug("recordingId=", recordingId)
			this._parent.fetchMarkers("handleSerieRecord")
			})
		})
		//if (this.getPlannedRecAndEvtIds().recIds.length > 0) this._parent.setTargetMarker(props, this.oEvent, { State: "Scheduled", isSeries: true })
		/*
		this.recordingState.series = true
		this.recordingState.single = false
		this.recordingState.seriesId = recordingId
		*/
		this.isDone = true
	})

	handleEpisodeDelete = flow(function* () {
		const _eventId = eventId(this.oEvent)
		// make a snapshot of 'id', since the returned marker will change
		const id = /*this.recordingState.singleId ||*/ this.marker?.id
		//const id = _eventId
		//this.recordingState.single = false
		//this.oRecMarkersTarget?.delete(_eventId)
		//this._parent.setTargetMarker(null, this.oEvent, { State: "Deleted" })
		yield this.manageRecordingsAsync({
			request: {
				ActionName: MANAGE_RECORDINGS_ACTIONS.Delete,
				Ids: id
			},
			// eventIds for removing bookmark
			eventIds: [_eventId]
		})
		this.recordingState.singleId = null
		//this._parent.closeRecordingEvent(this.oEvent)
		yield this.cocoBookmarks.informRecordingDeleted([_eventId], [id], null, true)
		this._parent.fetchMarkers("handleEpisodeDelete")
		this._parent.setTargetMarker(null, this.oEvent, { State: "Deleted" })
		this.recordingState.single = false
		this.isDone = true
	})

	handleEpisodeCancel = flow(function* () {
		const _eventId = eventId(this.oEvent)
		console.debug("handleEpisodeCancel", this.marker)
		// make a snapshot of 'id', since the returned marker will change
		const id = /*this.recordingState.singleId ||*/ this.marker?.id
		this.recordingState.single = false
		//this.oRecMarkersTarget?.delete(_eventId)
		this._parent.setTargetMarker(null, this.oEvent, { State: "Deleted" })
		yield this.manageRecordingsAsync({
			request: {
				ActionName: MANAGE_RECORDINGS_ACTIONS.Cancel,
				Ids: id
			},
			// eventIds for removing bookmark
			eventIds: [_eventId]
		})
		this.recordingState.singleId = null
		yield this.cocoBookmarks.informRecordingDeleted([_eventId], [id], null, true)
		this.isDone = true
	})

	handleSeriesCancel = flow(function* (findProps) {
		console.debug("handleSeriesCancel", findProps, this.recordingState.seriesId, this.marker?.id, this.recordingState.seriesId || this.marker?.id)
		// make a snapshot of 'id', since the returned marker will change
		const id = this.marker?.id
		//this.recordingState.seriesCancel = true
		if (this.recordingState.seriesDelete) this.recordingState.series = false
		//this._parent.setTargetMarker(null, this.oEvent, { State: "Deleted", isSeries: true })
		const recs = yield this.getRecordings({ Ids: id })
		/*
		const scheduled = this.recordedMarkers?.filter(item => item.State === "Scheduled" || item.State === "Recording")
		for (var i = 0; i < scheduled.length; i++) {
			//console.debug("State", scheduled[i].State, scheduled[i])
			// remove from recordedMarkers
			const index = this.recordedMarkers.findIndex(j => j.id === scheduled[i].id)
			if (index >= 0) this.recordedMarkers.splice(index, 1)
		}
		*/
		const recAndEvtIds = this.getPlannedRecAndEvtIds(true)
		console.debug("handleSeriesCancel", recs, recAndEvtIds, this.recordedMarkers)

		yield this.manageRecordingsAsync({
			request: {
				//ActionName: MANAGE_RECORDINGS_ACTIONS.Cancel,
				//Ids: recs.Data?.Recording?.[0]?.ParentRecordings?.id
				ActionName: MANAGE_RECORDINGS_ACTIONS.Delete,
				Ids: recAndEvtIds.recIds
			},
			eventIds: recAndEvtIds.evtIds
		})
		yield this.cocoBookmarks.informRecordingDeleted(recAndEvtIds.evtIds, recAndEvtIds.recIds, null, true)
		this._parent.fetchMarkers("handleSeriesCancel")
		this.recordingState.seriesCancel = true
		this.isDone = true
	})

	handleSeriesDelete = flow(function* (findProps, _seriesId = null) {
		console.debug("handleSeriesDelete", seriesId(this.oEvent), this.recordingState.seriesId, this.seriesMarker?.id, this.recordingState.seriesId || this.seriesMarker?.id)
		//debugger
		if (!_seriesId) _seriesId = this.seriesMarker?.id
		//this.recordingState.seriesDelete = true
		if (this.recordingState.seriesCancel) this.recordingState.series = false
		// MTVW-820: delete only completed recordings, keep planned recordings
		const recAndEvtIds = this.getCompletedRecAndEvtIds(true)
		let tDeleteSeries = recAndEvtIds.recIds
		// it might happen that the FactoryState of a serie is 'Active', but no children are present
		if (tDeleteSeries.length === 0) tDeleteSeries = _seriesId
		//console.debug("handleSeriesDelete id %s, recMarkers %o, completed %o, tDeleted %o", _seriesId, this.recordedMarkers, completed, tDeleteSeries)
		if (_seriesId) {
			yield this.manageRecordingsAsync({
				request: {
					ActionName: MANAGE_RECORDINGS_ACTIONS.Delete,
					//Ids: _seriesId
					Ids: tDeleteSeries
				},
				eventIds: recAndEvtIds.evtIds
			})
			yield this.cocoBookmarks.informRecordingDeleted(recAndEvtIds.evtIds, tDeleteSeries, _seriesId, true)
		}
		this._parent.fetchMarkers("handleSeriesDelete")
		this.recordingState.seriesDelete = true
		this.isDone = true
	})

	handleDeleteRecordings = flow(function* (findProps, routeParams) {
		//console.debug("routeParams", routeParams?.type)
		const tDeleteEvents = []
		const tCancelEvents = []
		const tDeleteSeries = []

		const handleDeleteRecording = i => {
			if (i.isSeries) {
				tDeleteSeries.push(i)
			}
			// MTVW-890: consider routeParams.type
			//} else if (i.State === "Scheduled" && i.Type === "Series") {
			// MTVW-953: || i.State === "Failed" was missing
			else if (routeParams?.type === "planned" && (i.State === "Scheduled" || i.State === "Recording" || i.State === "Failed")) {
				tCancelEvents.push(i)
			}
			//} else {
			else if ((routeParams?.type === "series" || routeParams?.type === "single" || routeParams?.type === "archived" || routeParams?.type === "newrecs") && i.State === "Complete") {
				tDeleteEvents.push(i)
			}
			if (i.Recordings?.length > 0) {
				console.warn("handleDeleteRecording", i.Recordings)
				i.Recordings.forEach(j => handleDeleteRecording(j))
			}
		}
		this.isLoading = true
		try {
			const recs = yield this.getRecordings(findProps)
			//const eventId0 = recs.DataArr?.[0]?.EventId
			//console.debug("handleDeleteRecordings", findProps, recs, eventId0)
			recs.Data?.Recording?.forEach(i => handleDeleteRecording(i))
			//console.debug("@@handleDeleteRecordings(findProps=%o) tDeleteEvents=%o tCancelEvents=%o tDeleteSeries=%o", findProps, tDeleteEvents, tCancelEvents, tDeleteSeries)

			const events = tCancelEvents?.length > 0 ? tCancelEvents : tDeleteEvents?.length > 0 ? tDeleteEvents : []
			const ids = []
			const evtIds = []
			events?.forEach(i => {
				ids.push(i.id)
				evtIds.push(i.EventId)
			})

			if (tCancelEvents?.length > 0) {
				yield this.manageRecordingsAsync({
					request: {
						ActionName: MANAGE_RECORDINGS_ACTIONS.Delete, //MANAGE_RECORDINGS_ACTIONS.Cancel,
						Ids: ids
					},
					// eventIds for removing bookmarks
					eventIds: evtIds
				})
				yield this.cocoBookmarks.informRecordingDeleted(evtIds, ids, null, true)
			}
			if (tDeleteEvents?.length > 0) {
				yield this.manageRecordingsAsync({
					request: {
						ActionName: MANAGE_RECORDINGS_ACTIONS.Delete,
						Ids: ids
					},
					// eventIds for removing bookmarks
					eventIds: evtIds
				})
				yield this.cocoBookmarks.informRecordingDeleted(evtIds, ids, null, true)
			}
			/* MTVW-890: commented
			if (tDeleteSeries?.length > 0) {
				yield this.manageRecordingsAsync({
					request: {
						ActionName: MANAGE_RECORDINGS_ACTIONS.Delete,
						Ids: tDeleteSeries.map(i => i.id)
					}
				})
			}
			*/
			yield this._root.page.singleton.customer?.fetchData()
			//this.isLoading = false
			//if (seriesId(this.oEvent)) yield this.getRecordedEpisodeMarkers(this.oEvent)
			this._parent.fetchMarkers("handleDeleteRecordings")
			yield this.checkForEmptySeries({ Ids: [routeParams.serieId] })
			this.isDone = true
			return true
		} catch (e) {
			//	this.isLoading = false
			this.error = TraxisError.getErrorIfInstanceOf(e)
			console.error("handleDeleteRecordings", e, this.error)
			//console.debug(this.error)
			//throw this.error
		}
	})

	checkForEmptySeries = flow(function* (findProps) {
		const recs = rootStore.api.GetRecordings({ ...{ isSeries: true, isRecorded: true, isPlanned: true, iLimit: 2000, isChildRecordings: true, isSortDesc: false }, ...{ Ids: findProps.Ids[0] } })
		yield recs.fetchDataAsync()
		//const seriesId = recs.Data?.Recording?.[0]?.ParentRecordings?.id
		const seriesId = recs.Data?.Recording?.[0]?.SeriesId
		if (!seriesId) return
		// Don't fetch from MsEpg, the event might not be in the window anymore
		/*
		const event = yield rootStore.page.MsEpg.getEventDetailsAsync(recs.Data.Recording[0].EventId)
		//console.debug("getting marker", event.content.SeriesId)
		const recorded = yield this.getRecordedEpisodeMarkers(event)
		*/
		const recorded = yield this.getRecordedEpisodeMarkers(null, seriesId)
		//console.debug("checkForEmptySeries", seriesMarker, recs, sRecs, recs.Data?.Recording?.[0]?.ParentRecordings?.id)
		//"9181b2e5-f322-40c6-b24d-643c86f34fdf"
		console.debug("series empty %o, nb %s, recs %o, recorded %o, seriesId %o", recorded.length === 0, recorded.length, recs, recorded, seriesId)
		//debugger
		if (recorded.length === 0) {
			console.debug("checkForEmptySeries calling handleSeriesDelete")
			yield this.handleSeriesDelete(findProps, findProps.Ids[0])
		}
	})

	handleVisibilityToggle = flow(function* () {
		//console.debug("handleVisibilityToggle, recId %s, isPersonal %s", this.marker.id, this.marker.IsPersonal)
		/*
		yield this.manageRecordingsAsync({
			request: {
				ActionName: MANAGE_RECORDINGS_ACTIONS.Update,
				Ids: this.marker.id,
				Arguments: {
					...{
						IsPersonal: !this.marker.IsPersonal,
					}
				}
			}
		})
		*/
		// make a snapshot of 'isPersonal', since the returned marker will change
		const isPersonal = !this.marker?.IsPersonal
		this._parent.setTargetMarker(null, this.oEvent, { IsPersonal: isPersonal })
		yield this.manageRecordingsAsync({
			request: {
				ActionName: isPersonal ? MANAGE_RECORDINGS_ACTIONS.AddToPersonalRecordings : MANAGE_RECORDINGS_ACTIONS.DeleteFromPersonalRecordings,
				Ids: this.marker?.id,
			}
		})
		this.isDone = true
	})

	handleArchiveToggle = flow(function* () {
		//console.debug("handleArchiveToggle, recId %s, deleteProtected %s", this.marker.id, this.marker.IsDeleteProtected)
		// make a snapshot of 'isDeleteProtected', since the returned marker will change
		const isDeleteProtected = !this.marker?.IsDeleteProtected
		this._parent.setTargetMarker(null, this.oEvent, { IsDeleteProtected: isDeleteProtected })
		yield this.manageRecordingsAsync({
			request: {
				ActionName: MANAGE_RECORDINGS_ACTIONS.Update,
				Ids: this.marker?.id,
				Arguments: {
					...{
						IsDeleteProtected: isDeleteProtected,
					}
				}
			}
		})
		this.isDone = true
	})

	/**
	 * @returns {import('store/api/GetRecordingsMarkers').GetRecordingsMarkersItemModel|null}
	 */
	get marker() {
		return this._parent.getMarker(eventId(this.oEvent))
	}

	get seriesMarker() {
		//console.debug("EventDetails instanceof", this.oEvent instanceof EventDetails, this.oEvent instanceof CoCo?.BrokerEventDetails, seriesId(this.oEvent))
		//console.debug("EventWithContent instanceof", this.oEvent instanceof EventWithContent, this.oEvent instanceof CoCo?.BrokerEventDetails, seriesId(this.oEvent))
		//console.debug("Events_Model instanceof", this.oEvent instanceof Events_Model)
		return this._parent.getMarker(null, seriesId(this.oEvent))
	}

	get isEventRecordable() {
		// MTVW-1075: IsNetworkRecordingAllowed was always set to true in EpgService
		return true
		//return this.oEvent?.IsNetworkRecordingAllowed === true
	}

	get isEventStarted() {
		return this.oEvent
	}

	get buttonsLists() {
		//if (!this.isRecordedAsSingle) return this._buttonLists //t
		// do not consider instances of 'Events' for indicattors in EPG
		// MTVW-1157: commented this.oEvent instanceof EventDetails
		if (!(/*this.oEvent instanceof EventDetails ||*/ this.oEvent instanceof CoCo?.BrokerEventDetails)) return this._buttonLists
		// check if recordedMarkers have been fetched
		if (!this.recordedMarkers) return this._buttonLists

		const t = {}
		/*
		console.debug("testing")
		const test = this.isRecordedAsSingle
		console.debug("test", test)
		test.then((res) => {
			//const data = rootStore.api.GetRecordings().fillData()
			console.debug("test=", res, res.isReady)
			//res = res.fillData()
			res?.DataArr?.map((i, ix) => {
				console.debug("item=", ix, i.Name, i.StartTime, i.State, i.Type, i.EventId, eventId(this.oEvent))
				if (i.EventId === eventId(this.oEvent)) recordedAsSingle = false
			})
		})
		*/
		// modification
		if (this.isRecorded) {
			// MTVW-500: condition for (pre-scheduled?) single recording
			// MTVW-518: comment change made in MTVW-500
			if (this.isRecordedAsSeries && !this.recordingState.single /*&& this.recordingState.seriesId*/ /*&& !this.isRecordedAsSingle*/) {
				if (this.getCompletedRecAndEvtIds().recIds.length > 0) t[RECORDING_OPTIONS.series_delete] = true
				if (this.getPlannedRecAndEvtIds().recIds.length > 0) t[RECORDING_OPTIONS.series_cancel] = true
			}

			// MTVW-500: condition for (pre-scheduled?) single recording
			// MTVW-518: comment change made in MTVW-500
			if (this.isRecordedAsSeries /*&& !this.isRecordedAsSingle*/) {
				//t[this.isRecordedComplete ? RECORDING_OPTIONS.series_episode_delete : RECORDING_OPTIONS.series_episode_cancel] = true
				if (this.isRecordedComplete) t[RECORDING_OPTIONS.series_episode_delete] = true
				// wait for valid marker
				else if (this.marker !== null && !this.marker.targetState) {
					t[RECORDING_OPTIONS.series_episode_cancel] = true
				}
			} else {
				//t[this.isRecordedComplete ? RECORDING_OPTIONS.episode_delete : RECORDING_OPTIONS.episode_cancel] = true
				if (this.isRecordedComplete) t[RECORDING_OPTIONS.episode_delete] = true
				// wait for valid marker
				else if (this.marker !== null && this.marker.targetState === undefined) {
					//console.debug("test", this.marker !== null, this.marker.targetState)
					t[RECORDING_OPTIONS.episode_cancel] = true
				}
			}
		}

		const states = {
			isRecordedAsSingle: this.isRecordedAsSingle,
			isRecordedAsSeries: this.isRecordedAsSeries,
			isRecordingStarted: this.isRecordingStarted,
			isEventInRecordedMarkers: this.isEventInRecordedMarkers,
			isRecorded: this.isRecorded,
			isEventSeries: this.isEventSeries,
			recordedLength: this.getCompletedRecAndEvtIds().recIds.length,
			plannedLength: this.getPlannedRecAndEvtIds().recIds.length,
			marker: this.marker,
			oRecMarkers: this._parent.oRecMarkers,
			oEvent: this.oEvent,
			title: title(this.oEvent),
			recordedMarkers: this.recordedMarkers,

		}
		console.debug("buttonsLists", states, this.isRecorded, this.recordedMarkers)
		// MTVW-1075: IsNetworkRecordingAllowed was always set to true in EpgService
		//if (this.oEvent?.IsNetworkRecordingAllowed === true) {
		if (true) {
			// adding
			// recordedAsSeries false, marker null, isEventInRecordedMarkers false. isRecored false, evtSeries true
			if (this.recordedMarkers) {
				// isEventInRecordedMarkers is valid
				/*
				if (!this.isRecorded) {
					t[this.isEventSeries && this.isEventInRecordedMarkers ? RECORDING_OPTIONS.series_episode_record : RECORDING_OPTIONS.episode_record] = true
				}
				if (this.isEventSeries && !this.isRecordedAsSeries && this.isEventInRecordedMarkers) {
					t[this.isRecorded ? RECORDING_OPTIONS.series_record_add : RECORDING_OPTIONS.series_record] = true
				}
				*/
				if (!this.isRecorded) {
					t[this.isEventSeries && !this.isRecordingStarted ? RECORDING_OPTIONS.series_episode_record : RECORDING_OPTIONS.episode_record] = true
				}
				if (this.isEventSeries && !this.isRecordedAsSeries && !this.isRecordingStarted) {
					t[this.isRecorded ? RECORDING_OPTIONS.series_record_add : RECORDING_OPTIONS.series_record] = true
				}
			}
		}
		/*
		const changes = getChanges(this._buttonLists, t)
		console.debug("buttonsLists getChanges", this._buttonLists, t, changes)
		if (JSON.stringify(changes) !== "{}") {
			console.debug("buttonsLists changes, _buttonLists %o, t %o, changes %o, json %o", this._buttonLists, t, changes, JSON.stringify(changes))
			this.setButtonLists(t)
		}*/
		if (!deepEqual(this._buttonLists, t)) {
			console.debug("buttonsLists changes, _buttonLists %o, t %o", this._buttonLists, t)
			this.setButtonLists(t)
		}
		return this._buttonLists
	}

	get isEventSeries() {
		return isSeries(this.oEvent)
	}

	get isRecorded() {
		return this.marker !== null || this.recordingState.single // DON'T SET | this.recordingState.series
	}

	get isPersonal() {
		return this.marker?.IsPersonal !== false
	}

	get isRecordedAsSeries() {
		// MTVW-500
		//console.debug("oEvent=", this.oEvent, rootStore.page.Recordings.IndexPage.isRecordedAsSingle(eventId(this.oEvent)))
		//return this.marker?.isSeries === true || isPlanned
		//console.debug("isRecordedAsSeries=", this.marker?.isSeries === true /*&& !rootStore.page.Recordings.IndexPage.isRecordedAsSingle(eventId(this.oEvent))*/)
		//return this.marker?.isSeries === true /*&& !rootStore.page.Recordings.IndexPage.isRecordedAsSingle(eventId(this.oEvent))

		// MTVW-518: revert change
		/*
		// provides more up-to-date information
		return rootStore.page.Recordings.IndexPage.isRecordedAsSeries(seriesId(this.oEvent)) ||
		rootStore.page.Recordings.IndexPage.isPlanned(seriesId(this.oEvent))
		*/
		return !this.isRecordedAsSingle && (this.marker?.isSeries === true || this.recordingState.series)
	}

	get isRecordedAsSingle() {
		// MTVW-820
		let recordedAsSingle = this.isRecorded
		if (recordedAsSingle) {
			for (var i = 0; i < this.recordedMarkers.length; i++) {
				if (this.recordedMarkers[i].EventId === eventId(this.oEvent)) recordedAsSingle = false
				//console.debug("test", this.recordedMarkers[i].EventId, eventId(this.oEvent), this.recordedMarkers[i].id === eventId(this.oEvent))
			}
		}
		console.debug("recordedAsSingle %o, isRecorded %o", recordedAsSingle, this.isRecorded)
		return recordedAsSingle

		/*
		const recList = this.seriesMarker ? this._root.api.GetRecordings({ ...{ isRecorded: true, isPlanned: true, iLimit: 2000, isChildRecordings: true, isSortDesc: false }, ...{ Ids: this.seriesMarker?.id } }).fillData() : null
		console.debug("isRecordedAsSingle marker %o, seriesMarker %o, id %s, listSize %s, list %o, event %o", this.marker, this.seriesMarker, this.seriesMarker?.id, recList?.DataArr?.length, recList?.DataArr, this.oEvent)
		console.debug("recList", recList, recList?.isReady, recList?.DataArr)
		//let recordedAsSingle = recList?.DataArr?.length > 0 ? true : false
		let recordedAsSingle = this.isRecorded
		if (recordedAsSingle) recList?.DataArr?.map((i, ix) => {
			//console.debug("item=", ix, i.Name, i.StartTime, i.State, i.Type, i.State, i.EventId, eventId(this.oEvent), i.EventId === eventId(this.oEvent))
			if (i.EventId === eventId(this.oEvent)) recordedAsSingle = false
		})
		console.debug("recordedAsSingle", recordedAsSingle, this.isRecorded)
		return { isReady: recList ? recList?.isReady : true, value: recordedAsSingle }
		*/
	}

	get isRecordedComplete() {
		return this.marker?.isComplete === true
	}
}

export class RecordingsManager extends PageAbstract {
	/**
	 * @type {import('store/api/GetRecordingsMarkers').GetRecordingsMarkersModel}
	 */
	oRecMarkers = rootStore.api.GetRecordingsMarkers()?.fetchData().Data

	oEvent = null
	oRecEvent = new RecordingsManagerEvent(this, "getRecordingEvent")

	// temporary target marker(s) for fast indicator, button updates and UI transitions
	oRecMarkersTarget = new Map()
	// stored manager events to avoid flickering of recordings buttons (could happen if an info page is opened from the live Tv tab)
	eventsMap = new Map()
	_observer = new Observe(this, "_observer")
	// WORKAROUND: When recording series with IsPersonal: true Traxis returns the IsPersonal: false for some seconds
	isVisibilityValid = true
	retransmissionNotRecorded = false

	constructor(parent, path) {
		super(parent, path)
		makeObservable(this, {
			oRecMarkers: observable.shallow,
			oRecMarkersTarget: observable.shallow,
			fetchMarkers: action,
			setTargetMarker: action,
			isVisibilityValid: observable,
			retransmissionNotRecorded: observable,
			setRetransmissionNotRecorded: action,
			_isTargetStateReached: action
		})
		this._addObserver()
		// MTVW-500
		this.fetchMarkers("inital")
		setInterval(() => {
			this.fetchMarkers("periodic")
		}, 30000)
	}

	setRetransmissionNotRecorded(value) {
		this.retransmissionNotRecorded = value
	}

	_addObserver() {
		try {
			this._observer.add("this.oRecMarkers.isReady", this.oRecMarkers, "isReady", changes => {
				if (changes.newValue) {
					//console.debug("_observer RecordingsManager %o", changes, this.eventsMap)
					this.eventsMap?.forEach((item) => {
						item.notifyRecordingsMarkersUpdate()
					})
				}
			})
		}
		catch (e) {
			console.error(" RecordingsManagern_addObserver", e)
		}
	}

	fetchMarkers(info) {
		try {
			this.oRecMarkers = rootStore.api.GetRecordingsMarkers()?.fetchData()?.Data
			//console.debug("fetchMarkers this.oRecMarkers=", info, this.oRecMarkers?.isReady, this.oRecMarkers?.isUpdated, this.oRecMarkers?.resultCount, this.oRecMarkers)
		}
		catch (e) {
			console.error("CAUGHT fetchMarkers", e)
		}
	}

	_isTargetStateReached(eventId, marker, targetMarker, seriesMarker) {
		const size = this.oRecMarkersTarget.size
		//if (targetMarker) console.debug("targetMarker=", targetMarker, marker, size)
		//const cachedTargetState = this.oRecMarkersTarget.get(eventId)
		//if (cachedTargetState?.State === "Deleted") this.oRecMarkersTarget.delete(eventId)
		const targetState = targetMarker?.targetState
		if (targetState && seriesMarker !== null) {
			if (targetState.isSeries) {
				this.isVisibilityValid = targetState.IsPersonal === seriesMarker?.IsPersonal
				if (this.isVisibilityValid) {
					console.debug("isVisibilityValid", this.isVisibilityValid, marker)
					if (!this.marker) this.setRetransmissionNotRecorded(true)
					this.oRecMarkersTarget.delete(eventId)
				}
				/*
				console.debug("targetState", targetState.isSeries, targetState.IsPersonal, seriesMarker?.IsPersonal)
				if (targetState.isSeries && targetState.IsPersonal !== seriesMarker?.IsPersonal) {
					console.debug("targetState not reached")
					//return false
				}
				else if (targetState.isSeries) {
					console.debug("targetState reached")
					this.oRecMarkersTarget.delete(eventId)
					//return true
				}
				*/
			}
			else this.isVisibilityValid = true
		}
		if (marker !== null /*|| seriesMarker !== null*/) {
			//computed(() => rootStore.page.Recordings.Manager.getMarker(eventId, null)).get()
			//const targetState = computed(() => targetMarker?.targetState).get()
			if (targetState) {
				console.debug("targetState", targetState, marker, seriesMarker)
				if (targetState.IsPersonal === marker.IsPersonal ||
					targetState.IsDeleteProtected === marker.IsDeleteProtected ||
					targetState.State === marker.State) {
					this.oRecMarkersTarget.delete(eventId)
					console.debug("entry deleted -1")
					return true
				}
				else return false
			}
			else return true
		}
		else {
			if (eventId && this.oRecMarkersTarget.get(eventId)?.targetState?.State === "Deleted") {
				this.oRecMarkersTarget.delete(eventId)
				console.debug("entry deleted -2")
				//return true
			}
			return false
		}
	}

	// CoCo Marker FIX (TODO: Handling of CoCo events)
	cocoMarkers = new Map()
	addCocoMarker(item) {
		//if (item.type === "event") console.debug("addCocoMarker", item, item?.data?.event?.id, item?.data?.recordingStates)
		if (item.type === "event") this.cocoMarkers.set(item.data.event.id, item.data.recordingStates)
		//console.debug("addCocoMarker", item, this.cocoMarkers)
	}

	/**
	 * @returns {import('store/api/GetRecordingsMarkers').GetRecordingsMarkersItemModel}
	 * @param {string} eventId
	 */
	getMarker(_eventId, _seriesId = null) {
		//console.debug("getMarker=", this.oRecMarkers.Recording.data_)
		// CoCo Marker FIX (TODO: Handling of CoCo events)
		let cocoMarker = this.cocoMarkers.get(_eventId)
		if (cocoMarker && cocoMarker.length > 1) {
			cocoMarker = cocoMarker?.[0]
			this.oRecMarkers.Recording.data_.forEach((values, key) => {
				//if (key === _eventId) console.debug("getMarker", values.value_.ProfileId === cocoMarker?.ProfileId, cocoMarker?.ProfileId, values.value_.ProfileId)
				if (key === _eventId && cocoMarker/*values.value_.ProfileId === cocoMarker?.ProfileId*/) { 
					console.debug("getMarker=HIT", _eventId, rootStore.sso.getProfile(values.value_.ProfileId)?.name)
					console.debug("getMarker=HIT", values.value_.ProfileId, cocoMarker.profileId)
					return values.value_
				}
				/*
				if (key === _eventId && values.value_.ProfileId === rootStore?.sso?.profile?.id) {
					console.debug("getMarker=OWN", values.value_)
				}
				*/
			})
		}
		let item = this.oRecMarkers?.getById(_eventId) ?? null
		const targetMarker = this.oRecMarkersTarget?.get(_eventId) ?? null
		const seriesMarker = this.oRecMarkers?.getById(seriesId(this.oEvent)) ?? null

		//if (seriesId(this.oEvent)) console.debug("getMarker SeriesId", this.oEvent, seriesId(this.oEvent))
		//console.debug("getMarker", _eventId, item)
		if (this._isTargetStateReached(_eventId, item, targetMarker, seriesMarker)) return item?.isDeleted || targetMarker?.isDeleted ? null : item

		if (_seriesId !== null) {
			/*
			console.debug("getById", this.oRecMarkers, this.oRecMarkers?._$Recording.data_?.[0])
			if (this.oRecMarkers) {
				this.oRecMarkers?._$Recording?.data_?.forEach?.(i => {
					if (i.value_.SeriesId === _seriesId) console.debug("getById", i.value_.SeriesId, i)
				})
			}
			*/
			item = this.oRecMarkers?.getById(_seriesId) ?? null
			if (!item) item = this.oRecMarkersTarget.get(_seriesId) ?? null
			if (!item) {
				item = this.oRecMarkers?.getSuspendedSeriesBy(_seriesId) ?? null
				if (item) console.debug("suspended series id", item)
			}
			if (item !== null) {
				return item
			}
		}
		if (targetMarker !== null) {
			//console.debug("oRecMarkersTarget item", targetMarker)
			//console.debug("addCocoMarker2 ev %o, 1 %o, 2 %o, map %o", _eventId, targetMarker, this.cocoMarkers.get(_eventId)?.[0], this.cocoMarkers)
			return targetMarker.targetState.State === "Deleted" ? null : targetMarker
		}
		if (_seriesId !== null) {
			return this.oRecMarkersTarget.get(_seriesId) ?? null
		}
		return null
	}

	// MTVW-820: performance optimization with ChildRecordings
	getMarkers(seriesMarker) {
		const childRecordingsIds = []
		const seriesItems = []
		seriesMarker?.ChildRecordings?.Recording?.forEach((item) => {
			childRecordingsIds.push(item.id)
		})
		this.oRecMarkers?._$Recording?.data_?.forEach((value, key, map) => {
			if (value?.value_?.State !== "Complete" && value?.value_?.State !== "Scheduled" && value?.value_?.EventId) {
				//console.debug("getMarkers", value?.value_?.State, value?.value_)
				rootStore.api.GetRecordings({ ...{ isRecorded: true, isPlanned: true, iLimit: 1, isChildRecordings: true, isSortDesc: false }, ...{ Ids: value?.value_?.id } }).fetchDataAsync().then((res) => {
					console.debug("%o, fetched", value?.value_?.State, res?.json?.Recordings?.Recording?.[0], res?.data ? JSON.parse(res.data) : "")
				})
			}
			const recordingId = value?.value_?.id
			if (childRecordingsIds.includes(recordingId)) {
				//console.debug("HIT", value?.value_, seriesMarker)
				seriesItems.push(value?.value_)
			}
			//console.debug("key %o, value %o, map %o", value[0], value[1].value_.id, childRecordingsIds)
		})
		//console.debug("Children", seriesMarker.ChildRecordings, seriesItems)
		return seriesItems
	}

	/**
	 * @returns {RecordingsManagerEvent}
	 * @param {*} oEvent
	 */
	getRecordingEvent(oEvent) {
		//console.debug("RecordingsManager CoCo", CoCo, this.oEvent instanceof CoCo?.BrokerEventDetails, this.oEvent)
		// MTVW-1157: commented this.oEvent instanceof EventDetails
		const storedEvent = /*this.oEvent instanceof EventDetails ||*/ this.oEvent instanceof CoCo?.BrokerEventDetails ? this.eventsMap.get(eventId(oEvent)) ?? null : null
		//const storedEvent = eventId(this.oEvent) ?? null //this.oEvent instanceof EventDetails ? this.eventsMap.get(eventId(oEvent)) ?? null : null
		//if (this.oEvent instanceof EventDetails || this.oEvent instanceof CoCo?.BrokerEventDetails) console.debug("getRecordingEvent=", eventId(oEvent), storedEvent, this.eventsMap)
		if (storedEvent) return storedEvent
		// MTVW-518: Live Tv issue, when switching the channel, the recording buttons did show the status of the previous channel
		// Generate a new RecordingsManagerEvent if the event changes
		if (this.oEvent !== oEvent) {
			this.oRecEvent = new RecordingsManagerEvent(this, "getRecordingEvent")
			this.oEvent = oEvent
		}
		//if (!(this.oEvent instanceof EventDetails || this.oEvent instanceof CoCo?.BrokerEventDetails) && title(this.oEvent)?.startsWith("Mini")) debugger
		//console.debug("getRecordingEvent", title(oEvent), oEvent, this.oRecEvent.setEvent(oEvent))
		const value = this.oRecEvent.setEvent(oEvent)
		//if (this.oEvent instanceof EventDetails || this.oEvent instanceof CoCo?.BrokerEventDetails) this.eventsMap.set(eventId(this.oEvent), value)
		// MTVW-1157: commented this.oEvent instanceof EventDetails
		if (/*this.oEvent instanceof EventDetails ||*/ this.oEvent instanceof CoCo?.BrokerEventDetails) this.eventsMap.set(eventId(this.oEvent), value)
		return value
	}

	closeRecordingEvent(oEvent) {
		//console.debug("closeRecordingEvent", this.eventsMap.delete(eventId(this.oEvent)))
		//if (this.oEvent === oEvent) {
		console.debug("closeRecordingEvent", oEvent)
		// MTVW-1157: commented this.oEvent instanceof EventDetails
		if (/*this.oEvent instanceof EventDetails ||*/ this.oEvent instanceof CoCo?.BrokerEventDetails) this.eventsMap.delete(eventId(this.oEvent))
		this.oRecMarkersTarget?.clear()
		//}
	}

	/**
	 * @returns {RecordingsManagerEvent}
	 * @param {*} oEvent
	 */
	get recordingManager() {
		// MTVW-1037: Why was the event reset by Kamil Michalak?
		//return this.oRecEvent.setEvent(null)
		return this.oRecEvent
	}

	setTargetMarker(props, event, request) {
		const _eventId = eventId(event)
		if (!_eventId) return
		let tgMarker = this.getMarker(_eventId)
		console.debug("setTargetMarker tgMarker %o, event %o, request %o", tgMarker, event, request)
		if (!tgMarker) {
			tgMarker = new GetRecordingsMarkersItem()
			tgMarker.EventId = _eventId
			tgMarker.SeriesId = request.SeriesId
			tgMarker.ProfileId = rootStore?.sso?.profile?.id
			tgMarker.IsPersonal = request?.IsPersonal
			if (request.State !== undefined) tgMarker.State = request.State
			tgMarker.targetState = request
			if (request.isSeries && isSeries(event)) tgMarker.SeriesId = seriesId(event)
			this.oRecMarkersTarget.set(_eventId, tgMarker)
			console.debug("setTargetMarker props %o, event %o, tgMarker %o", props, event, tgMarker)
		}
		else {
			const tgMarkerCopy = new GetRecordingsMarkersItem()
			Object.assign(tgMarkerCopy, tgMarker)
			tgMarkerCopy.targetState = request
			console.debug("tgMarkerCopy=", tgMarkerCopy, request)
			if (request.IsPersonal !== undefined) {
				console.debug("change IsPersonal %s to %s", tgMarkerCopy.IsPersonal, request.IsPersonal)
				tgMarkerCopy.IsPersonal = request.IsPersonal
				this.oRecMarkersTarget.set(_eventId, tgMarkerCopy)
			}
			if (request.IsDeleteProtected !== undefined) {
				console.debug("change IsDeleteProtected %s to %s", tgMarkerCopy.IsDeleteProtected, request.IsDeleteProtected)
				tgMarkerCopy.IsDeleteProtected = request.IsDeleteProtected
				this.oRecMarkersTarget.set(_eventId, tgMarkerCopy)
			}
			if (request.State !== undefined) {
				console.debug("change State %s to %s", tgMarkerCopy.State, request.State, tgMarkerCopy)
				tgMarkerCopy.State = request.State
				this.oRecMarkersTarget.set(_eventId, tgMarkerCopy)
			}
		}
	}
}
